import { render, staticRenderFns } from "./standardized-contract.vue?vue&type=template&id=1452658d&"
import script from "./standardized-contract.vue?vue&type=script&lang=js&"
export * from "./standardized-contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports